import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { AppContext } from 'contexts';
import classNames from 'classnames';

const useStyles = makeStyles({
  arrowBox: {
    position: 'absolute',
    top: '50%',
    width: '5rem',
    height: '5rem',
    transform: 'translateY(-50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(0,0,0,0.3)',
    pointerEvents: 'auto',
    userSelect: 'none',
    cursor: 'pointer',

    '&.left': {
      left: 0,
    },

    '&.right': {
      right: 0,
    },
  },
});

function Navigator() {
  const classes = useStyles();
  const appContext = useContext(AppContext);
  const { currentMarkerInc, currentMarkerDec } = appContext;

  return (
    <>
      <div className={classNames(classes.arrowBox, 'left')} onClick={currentMarkerDec}>
        <img src='/left_arrow.png' alt='Arrow' onTouchEnd={currentMarkerDec} />
      </div>
      <div className={classNames(classes.arrowBox, 'right')} onClick={currentMarkerInc}>
        <img src='/right_arrow.png' alt='Arrow' onTouchEnd={currentMarkerInc} />
      </div>
    </>
  );
}

export default Navigator;
